import { Component } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'version-control',
    templateUrl: 'version.control.html',
    standalone: false,
})
export class VersionControl extends ControlBase {}
